import styled from 'styled-components';
import { width, LayoutProps } from 'styled-system';

export const Container = styled.div`
  width: 100%;
`;

export const Socket = styled.div<LayoutProps>`
  ${width};
  height: 100%;
`;
